<template>
  <div class="container-table-striped">
    <div class="table-hover">
      <table class="table content-table-striped table-striped mb-5">
        <thead>
          <tr class="row global-thead-dark thead-property pl-1">
            <th class="col-12">
              Información Adicional
            </th>
          </tr>
        </thead>
        <tbody>
          <tr class="row pl-2">
            <td class="col-md-12 pl-3 text-left">
              <WizardQuestion
                v-for="item in items"
                :id="`qQuestions-${item.id}`"
                :ref="'id_' + item.id"
                :key="item.id"
                :description="item.title"
                :answer-control-type="1"
                :hide-icon-box="false"
                @questionChange="questionChange"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import WizardQuestion from '@/components/pei/WizardQuestion';
export default {
  name: 'ControversyList',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    questionChange() {},
  },
  components: {
    WizardQuestion,
  },
};
</script>

<style scoped>
.thead-property {
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 5px 5px 0px 0px;
}
</style>
